import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Container } from '@/components/ui'
import SEO from '@/utils/seo'

export default function NotFoundPage() {
  const { t } = useTranslation()

  return (
    <section
      className="py-section-y px-section-x min-h-[50vh] sm:min-h-[60vh] flex items-center justify-center"
      aria-labelledby="not-found-title"
    >
      <SEO
        title={t('seo.notFoundTitle')}
        description={t('notFound.text')}
        keywords={t('seo.notFoundKeywords')}
        noindex
      />
      <Container>
        <div className="text-center">
          {/* `aria-labelledby` lives on the <section> above; the heading
              id drives the accessible name for the whole region. The 404
              ornament is purely visual — read it as text so screen readers
              still announce the heading.

              Phase 1 mobile (2026-10-13): was `text-6xl md:text-8xl`
              (60 / 96 px). 60 px is too tight on a 360 px viewport
              (the number consumed the full content width), and 96 px
              made a single character dominate the page. 48 / 72 px
              keeps the impact without overshooting. */}
          <h1
            id="not-found-title"
            className="hero-title text-5xl md:text-7xl text-primary mb-4"
          >
            404
          </h1>
          <p className="text-ink-soft mb-8">{t('notFound.text')}</p>
          <Link
            to="/"
            className="inline-block bg-primary text-surface px-6 py-3 rounded-yada-lg hover:bg-primary-dark transition-colors focus-visible:outline-2 focus-visible:outline-primary focus-visible:outline-offset-2"
          >
            {t('notFound.back')}
          </Link>
        </div>
      </Container>
    </section>
  )
}